var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5872 0.800781C16.7051 0.800781 18.7999 2.98854 18.7999 6.2435V13.7581C18.7999 17.013 16.7051 19.2008 13.5863 19.2008H5.6117C2.49382 19.2008 0.399902 17.013 0.399902 13.7581V6.2435C0.399902 2.98854 2.49382 0.800781 5.6117 0.800781H13.5872ZM13.5872 2.18078H5.6117C3.2841 2.18078 1.7799 3.77514 1.7799 6.2435V13.7581C1.7799 16.2264 3.2841 17.8208 5.6117 17.8208H13.5863C15.9148 17.8208 17.4199 16.2264 17.4199 13.7581V6.2435C17.4199 3.77514 15.9157 2.18078 13.5872 2.18078ZM9.59907 5.29369C9.97995 5.29369 10.2891 5.60281 10.2891 5.98369V9.60481L13.073 11.2636C13.3996 11.4595 13.5072 11.8827 13.3122 12.2103C13.1825 12.4265 12.9534 12.547 12.7188 12.547C12.5983 12.547 12.4768 12.5157 12.3655 12.4504L9.24579 10.5892C9.03787 10.4641 8.90907 10.2387 8.90907 9.99673V5.98369C8.90907 5.60281 9.21819 5.29369 9.59907 5.29369Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/watch.8eafa8bd10d53832a5817a10c06bb128.svg";
export { ForwardRef as ReactComponent };